import React, { createContext, useState, useContext, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { market } from "../CommonPage/MarketFlow/TradeData";
import { comment } from "stylis";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();

  // Extract language from URL, default to 'en' if not present
  const getLangFromPath = () => {
    const match = location.pathname.match(/^\/(en|fr)(\/|$)/);
    return match ? match[1] : "en";
  };

  const [language, setLanguage] = useState(getLangFromPath());

  // Update language if URL changes
  useEffect(() => {
    const urlLang = getLangFromPath();
    if (urlLang !== language) {
      setLanguage(urlLang);
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  const translations = {
    en: {
      bannerTitle: "Born for",
      bannerTitle2: "Traders.",
      bannerSubtitle: "Built to perform.",
      bannerDescription: "Licensed, liquid, and built for speed — everything",
      bannerDescription2: "serious traders need.",
      openAccountButton: "Open Trading Account",
      trading: "Trading",
      promotions: "Promotions",
      Partnership: "Partnership",
      company: "Company",
      accountType: "Account Types",
      signUp: "Sign Up",
      SiggnUP: "Get Started",
      Accounts: "Accounts",
      Metalsbotom: " Ready to Trade Metals With",
      Metalsbotom1:
        "Start trading some of the most valuable assets on the planet with a",
      Metalsbotom2: "global broker. Open an account in seconds.",
      market: "Market",
      companyInfo: "Company",
      Platforms: "Platforms",
      ourOffering: "Our Offerings",
      Easy: "Easy Access to 1,400+ Global Assets",
      login: "Login",
      forexTrade: "Forex Trade",
      stockDerivatives: "Stock Derivatives",
      commodities: "Commodities",
      crypto: "Crypto",
      Indices: "Indices",
      Energies: "Energies",
      Stocks: "Stocks",
      preciousMetals: "Precious Metals",
      shares: "Shares",
      cryptoCurrencies: "Crypto Currencies",
      equityIndices: "Equity Indices",
      energies: "Energies",
      Referrals: "Referrals",
      AllReff: "Referrals (Coming Soon)",
      ReComing: "(Coming Soon)",
      bbcropCopyTrading: "BBCorp Copy trading",
      bbcropCompetitions: "BBCorp Competitions",
      executionPolicy: "Execution Policy",
      marginLeverage: "Margin & Leverage",
      mt5Platforms: "MT5 Platforms",
      partnerWithUs: "Partner with us",
      whoIsBBCorp: "KYC & AML",
      FoterSupport: "Support",
      careers: "Careers",
      careersTitle: "Join Our Team",
      careersSubtitle: "Be part of a dynamic team that's shaping the future of trading. We're looking for passionate individuals who are ready to make a difference.",
      regulation: "Regulation",
      legalDocuments: "Legal Documents",
      bbcropAwards: "BBCorp Awards",
      contactUs: "Contact Us",
      helpCenter: "Help Center",
      partnership: "Partnership",
      easyAccessTo: "Easy Access to",
      global: "Global",
      assets: "Assets",
      tradingNew: {
        titleLine1: "Discover Forex",
        titleLine2: "Trading",
        active: "Forex Trading",
        tradingBTN: "Open Trading Account",
        subtitle:
          "Buy and sell in the most liquid global markets, like EURUSD, 5 days a week with market-leading execution and trading conditions.",
      },
      tradingNew1: {
        titleLine1: "Discover Stocks",
        active: "Stock Derivatives",
        titleLine2: "Derivatives Trading",
        subtitle:
          "Trade your favorite brands from Netflix to Apple as stock derivatives with competitive conditions and pricing.",
      },
      commoditiesTrading: {
        titleLine1: "Discover",
        active: "Commodities",
        titleLine2: "Commodities",
        subtitle:
          "Trade soft Commodities like coffee and sugar with excellent conditions.",
      },

      metalsTrading: {
        titleLine1: "Discover Metals",
        active: "Precious Metals",
        titleLine2: "Trading",
        subtitle:
          "Trade soft Commodities like coffee and sugar with excellent conditions.",
      },
      sharesTrading: {
        titleLine1: "Discover",
        active: "Shares",
        titleLine2: "Shares",
        subtitle:
          "Trade real stocks of global companies including Apple, Disney, and Microsoft from your BBCorp account.",
      },
      cryptoTrading: {
        titleLine1: "Discover Crypto",
        titleLine2: "Derivatives Trading",
        active: "Cryptocurrencies",
        subtitle:
          "Trade Crypto derivatives including Bitcoin at real-time prices with unparalleled conditions.",
      },
      equityIndicesTrading: {
        titleLine1: "Discover Equity",
        titleLine2: "Indices",
        active: "Equity Indices",
        subtitle:
          "Trade combinations of world-renowned shares with our elite selection of equity indices.",
      },
      energiesTrading: {
        titleLine1: "Discover Energies",
        titleLine2: "Trading",
        active: "Energies",
        subtitle:
          "Trade oil and gas variants with low costs and competitive conditions.",
      },
      optionsTab: {
        name: "Forex Trading",
        name1: "Cryptocurrencies",
        name2: "Stock Derivatives",
        name3: "Commodities",
        name4: "Equity Indices",
        name5: "Precious Metals",
        name6: "Energies",
        name7: "Shares",
      },
      whyTrade: "Why Trade forex with BBCorp?",
      whyTradeindices: "Why trade equity indices with BBCorp?",
      Tradesf:
        "Trade the world’s first currencies and most precious assets on the planet",
      ClainT:
        "Claim your piece of the world's most successful companies and expand your potential.",
      EnergiesD:
        "Take advantage of the most liquid energies that are renowned for their trading potential.",
      trafeEWn: "Why Trade Energies With BBCorp?",
      trafeEWn1: "Why Trade Energies With",
      whyTradeSub:
        "Enter the world’s most liquid market with the confidence of having a leading broker at your side.",
      cardsDataeEn: {
        title1: "Trade 24/5",
        description1:
          "Explore the global currency markets with<br/> uninterrupted trading opportunities.",

        title2: "Stay Connected",
        description2:
          "Trade with full flexibility from Whatsapp to the BBCorp MetaTrader 5 app.",

        title3: "Magnify Your Trades",
        description3:
          "Boost the potential of your trades with<br/> leverage for traders of all levels.",

        title4: "Forget Charges",
        description4:
          "Use your money to trade, not to pay for services.<br/> You can enjoy no hidden fees or extra charges.",
      },
      indicesCardData: {
        title: "Trade Multiple Brands",
        description:
          "You can trade groups of global brands in one asset, maximizing your diversification.",
        title1: "Buy and Sell Indices",
        description1:
          "Trade both rising and falling markets with equity indices, taking advantage of all conditions.",
        title2: "Portfolio Diversification",
        description2:
          "Reduce potential risk and gain exposure to a wider range of opportunities.",
        title3: "Forget Charges",
        description3:
          "Use your money to trade, not to pay for services, with no hidden fees or extra charges.",
      },
      energiesCardData: {
        title: "Trade Top Energies",
        description:
          "You can trade groups of global brands in one asset, maximizing your diversification.",
        title1: "Cut Your Costs",
        description1:
          "Trade both rising and falling markets with equity indices, taking advantage of all conditions.",
        title2: "Magnify Your Trades",
        description2:
          "Reduce potential risk and gain exposure to a wider range of opportunities.",
        title3: "Forget Charges",
        description3:
          "Use your money to trade, not to pay for services, with no hidden fees or extra charges.",
      },

      alternativeAssetsCardData: {
        title: "Diversify Your Portfolio",
        description:
          "Trade alternative assets that tend to thrive in different market conditions.",
        title1: "Trade Without Owning",
        description1:
          "Speculate on price movements without the hassle and cost of owning the assets.",
        title2: "Magnify Your Trades",
        description2:
          "Boost the potential of your trades with leverage for traders of all levels.",
        title3: "Enjoy No Extra Fees",
        description3:
          "Focus on trading with no extra commission or hidden fees.",
      },

      cardsDataCommom: {
        title: "Diversify Your Portfolio",
        description:
          "Diversify your portfolio with assets affected by different fundamentals and trends.",
        title1: "Go Long and Shorts",
        description1: "Capitalise on all price movements including downtrends.",
        title2: "Trade Without Owning",
        description2:
          "Trade the assets without worrying about physically owning them.",
        title3: "Lower Your Costs",
        description3:
          "Trade without the high stock exchange cost or any hidden fees.",
      },
      cardDataEncosts: {
        title1: "Cut your costs",
        description1:
          "Skip stock exchange costs and trade straight from your BBCorp account",

        title2: "Buy and sell stocks",
        description2:
          "Buy and sell assets to take advantage of all market conditions.",

        title3: "Pay 0 commissions",
        description3:
          "Lower your costs and increase your potential with 0 commissions",

        title4: "Trade fractional shares",
        description4:
          "Use your money to trade, not to pay for services. You can enjoy no hidden fees or extra charges.",
      },

      cardDataObj: {
        // English
        title1: "Trade Global Shares",
        description1:
          "Trade the world with access to Shares from the USA, Europe and the UK.",

        title2: "Access 100s of Options",
        description2:
          "Diversify with brands in tech, fashion, travel, sports, and more.",

        title3: "Lower Your Costs",
        description3: "Choose cost-effective trading with no hidden fees.",

        title4: "Pick Your Brands",
        description4:
          "Turn brands you believe in, into an investment opportunity.",
      },

      ourInvestors: {
        title: "Discover Our Investor's",
        favorites: "Favorites",
        subtitle:
          "Recognized by the industry. Rewarding our partners. Built to grow with you.",
        metaTrader: {
          title: "MetaTrader 5",
          description:
            "Get full access to BBCorp services with the top-rated, award-winning MT5 App.",
          getItOn: "GET IT ON THE",
          playStore: "Play Store",
          downloadOn: "Download on the",
          appStore: "App Store",
          openAccount: "Open an account",
        },
      },
      whatsAppTrading: {
        title: "WhatsApp Trading?",
        subtitle:
          "Open your account under 2 minutes on our BBCorp WhatsApp portal",
        openWhatsApp: "Open WhatsApp Portal",
        title1: "Tens of Deposit Methods",
        description1:
          "Seamlessly add funds through a wide range of deposit options tailored to your needs — from local bank transfers and credit cards to global stablecoins and cash agents. Whether you’re on the move or managing from home, funding your account has never been easier or more flexible.",
        title2: "Advanced Infrastructure & Automation",
        description2:
          "Our AI-driven infrastructure oversees every stage—from onboarding and deposit processing to real-time transactions, behavioral monitoring, risk management, and seamless withdrawals.",
      },
      Discover: {
        title: "Built for growth",
        subtitle: "Discover our markets",
        description:
          "We serve institutional and individual clients executing trades",
        description1:
          "worldwide — delivering precision, speed, and reliability anytime",
        description2: "anywhere.",
      },
      Bonus: {
        title: "Refer & Earn",
        favorites: "Terms & Conditions apply.",
        subtitle:
          "Earn rewards whenever someone you refer signs up and trades. Share your link and get rewarded—simple as that.",
        openAccount: "Claim Your Bonus",
      },
      Competitions: {
        title: "BBCorp Competitions",
        subtitle: "Trade your way to the top and win your share of",
        subtitle1: "$100,000+ in withdrawable cash prizes.",
        openAccount: "Coming Soon",
      },
      deposit: {
        title: "Multiple deposit methods",
        subtitle: "From bank transfers to crypto to even",
        subtitle1: "local cash providers, we do it in more than",
        subtitle2: "180+ countries",
        openAccount: "View Deposit Method",
      },
      acountSection: {
        title: "Open and Grow Today",
        subtitle:
          "Open an account today and access an opportunity to grow your wealth in a secure, and trustable institution.",
        btnTitle: "Open an account now",
        cardsTitle: {
          title: "Standard Account",
          title1: "Trader Account",
          title2: "Investor Account",
          sub: "Account",
          subtitle:
            "Open our most popular account which has no commission while trading",
          subtitle1:
            "Perfect for high-volume trading with low spreads, reduced swaps, and commissions.",
          subtitle2:
            "Want to invest in stocks? Open a shares account to access market opportunities.",
          btnTitle: "Minimum Deposit $10",
          btnTitle1: "Minimum Deposit $10",
          btnTitle2: "Minimum Deposit $30,000",
          bltile: "Get Started",
          Markets: "Markets",
          marketSub:
            "Forex, Precious Metals, Equity Indices, Cryptocurrencies, Thematic Indices, Stocks,Turbo Stocks, Commodities, Energies",
          marketT1: "Bonus Eligibility*",
          marketT2: "Micro Account Options",
          marketT3: "100:1",
          marketT4: "Maximum Leverage",
          marketT5: "20%",
          marketT6: "Stop Out Level",
          marketT7: "Swap Free",
          marketT8: "Commission",
          marketT9: "Minimum Deposit",
          marketT10: "$10",
          marketT11: "Spreads as low as",
          show: "Show more",
          less: "Less more",
          firsy:
            "All accounts offer negative balance protection, hedging and Islamic options as standard. If the currency you deposit",
          firsy1:
            "into your account is not USD, the amount shown is the equivalent in the deposit currency.",
          spreads: [
            {
              pair: "GOLD",
              value: "2.7",
            },
            {
              pair: "USD/JPY",
              value: "2",
            },
            {
              pair: "USD/JPY",
              value: "1.6",
            },
          ],
          tier: "*Some countries might be excluded",
        },
      },
      PickData: "Pick Your Pairs",
      PickDatayour: "Pick your energies",
      commonit: "Ready to Trade Commodities",
      commonit1: "With BBCorp?",
      commonitEqu1:
        "Start exploring some of the most popular indices with a leading",
      commonitEqu2: "broker. Open an account within seconds.",
      commonitEqu: "Ready to trade equity indices",
      comment2:
        "Start trading popular Commodities with an industry-leading broker.",
      comment3: "Open an account within seconds.",
      PickDatayourDes: "You can see all trading hours in the Members Area.",
      bttomTxt:
        " Explore beyond the top 10 Stock derivatives! Ready to discover more?",
      RegisBTN: "Register to see more",
      IndicesTitle: "Indices",
      IndicesTitleFuture: "Future Indices",
      moreInfo: " *More info",
      IndicesTitleFutureCash: "Cash Energies",
      RegisBTNindices: "Pick your equity indices",
      RegisBTNiTitle: "You can see all trading hours in the Members Area.",
      CommoditiesTile: "Pick Your Commodities",
      CommoditiesTileDes: "You can see all trading hours in the Members Area.",
      metalsTitle: "Pick your precious metals",
      metalsTitleDes: "You can see all trading hours in the members area.",
      shareTitle: "Pick Your Share",
      Entitle:
        "Experience trading global energies with a leading broker that always",
      Entitle1: "has your back. Open an account within seconds.",
      shareTitleDes:
        "You can see all trading hours and stay updated on corporate events in the Members Area.",
      tab1: "Standard",
      tab2: "Ultra Low Standard",
      tab3: "Futures",
      derivate: "Pick Your Stock Derivatives",
      desDerivate:
        "You can see all trading hours and stay updated on corporate events in the Members Area.",
      tableData: {
        Symbol: "Symbol",
        AverageSpread: "Average Spread (pips)",
        Spread: "Spread as low as (pips)",
        MaxLeverage: "Max Leverage",
        Action: "Action",
      },

      picDec: "The Forex market operates Monday – Friday 00:05 – 23:50 GMT+2",
      footerAccounts: "Accounts",
      footerMarket: "Market",
      footerOffering: "Our Offering",
      footerPlatform: "Platforms",
      footerSupport: "Support",
      footerAccount: "Account Types",
      footerForex: "Forex Trade",
      footerStock: "Stock Derivatives",
      blueBTN: "Start Trading Now",
      footerCommaondities: "Commodities",
      footerPrecious: "Precious Metals",
      footerShares: "Shares",
      cryptoTitle: "Pick Your Cryptocurrencies",
      cryptoTitleDes: "The Crypto market operates 24/7.",
      footerCrypto: "Crypto Currencies",
      footerEquity: "Equity Indices",
      footerEnergies: "Energies",
      footerTrading: "BBCorp Copy trading",
      footerCompetitions: "BBCorp Competitions",
      footerPolicy: "Execution Policy",
      footerLeverage: "Margin & Leverage",
      footerMt5: "MT5 Platforms",
      footerHelp: "Help and Support",
      footerContact: "Contact Us",
      footerPolicy: "Privacy policy",
      footerTerm: "BBCorp Terms",
      footerButtontitle: "GET IT ON",
      footerButtonName: "Google Play",
      footerButton2title: " Download on the",
      footerButton2Name: "App Store",
      footerPayment: "Payment Accepted",
      footerLegal: "Legal Documentation",
      footerCopy: "Copyright",
      footerRight: "BBCrop LTD. All rights reserved",
      footerNews: "CFD’s are complex instruments and come with a high risk of losing money rapidly due to leverage. 77% of retail investor accounts lose money when trading CFD’s with this provider. You should consider whether you understand how CFD’s work and whether you can afford to take the high risk of losing your money. We recommend you seek professional advice before investing. BBCorp Lebanon (Beirut Brokerage Corporation s.a.l) is regulated by the Banque du Liban and supervised by the Capital Markets Authority. We do not provide investment advice or management services.Any analysis, opinion, commentary, or research-based material on our website is for information and educational purposes only and is not, under any circumstances, intended to be an offer, recommendation, advice, or solicitation to buy or sell.We are pleased to receive account applications from a wide range of countries. However, while we cannot currently accept applications from certain countries, we encourage you to apply if you meet our eligibility criteria, and we appreciate your interest in our services. Deposits and withdrawals may be coordinated, facilitated, or processed by one or more of the affiliates.",
      footerDescription:
        "CFD’s are complex instruments and come with a high risk of losing money rapidly due to leverage. 77% of retail investor accounts lose money when trading CFD’s with this provider. You should consider whether you understand how CFD’s work and whether you can afford to take the high risk of losing your money. We recommend you seek professional advice before investing. BBcorp LTD (Comoros) Limited is a company incorporated with limited liability under the laws of the C O M O R O S U N I O N, under registration number HV00724047, with its registered address at Bonovo Road – Fomboni -Island of Mohéli – Comoros Union. BBCorp LTD (Comoros) Limited is authorized Mwali International Services Authority as an International Brokerage and Clearing House License number BFX2024241. And at its physical office in Cyprus at Taki Sofokleous 23A -2049, Strovolos, Nicosia. We provide an execution-only service. We do not provide investment advice or management services. Any analysis, opinion, commentary, or research-based material on our website is for information and educational purposes only and is not, under any circumstances, intended to be an offer, recommendation, advice, or solicitation to buy or sell. We are pleased to receive account applications from a wide range of countries. However, while we cannot currently accept applications from certain countries, we encourage you to apply if you meet our eligibility criteria, and we appreciate your interest in our services. Deposits and withdrawals may be coordinated, facilitated, or processed by one or more of the affiliates of BBCorp LTD, including BBcorp LB.",
      weathTitle: " Begin your wealth",
      weathTitles: " journey with us",
      joinTitle:"Join Us",
      joinDes:"We pioneered the strict no requotes, no rejections policy that established our reputation. To prevent slippage and keep your strategy aligned with real-time market prices, 99% of all trades are executed in less than one second.",
      weathSetUp : "Instant Setup",
      weathSupport: "24/7 Support",
      weathLiquidity: "Deep Liquidity",
      weathButton: "Contact Sales",
      sliderTitle: "International Licenses. Local Trust.",
      sliderDescription:"At BBCorp, compliance isn’t a formality—it’s a foundation. We operate under a growing framework of international regulatory standards that ensures every aspect of our business is secure, transparent, and built to scale globally. As we expand our footprint across new markets, we remain committed to maintaining the highest levels of trust, governance, and operational integrity.",
      sliderCard1: "Best Broker",
      sliderCard2: "Middle East",
      shareCom: "Why Trade Shares",
      shareCom1: "With BBCorp?",
      shareComDes: "Claim your piece of the world's most successful companies",
      shareComDes1: "and expand your potential.",
      sliderCard3: "Most Trusted",
      sliderCard4: "MISA Asia",
      sliderCard5: "Top Broker",
      sliderCard6: "Africa",
      sliderCard7: "Fastest Growing",
      sliderCard8: "Global",
      globeHead: "Internationally Recognized",
      globeTitle: " Executing on the global stage",
      globeDesc:
        "We serve institutional and individual clients executing trades worldwide — delivering  precision, speed, and reliability, anytime, anywhere.",
      globeNumber: "10,000+",
      globeNumbers: "1000+",
      globeNumber2: "Happy Clients",
      globeNumber3: "2004",
      globeNumber4: "Est.",
      globeNumber5: "Transactions",
      globeNumber6: "3",
      newWealthTitle: "Not ready for the",
      newWealthTitle2: "real deal?",
      globeNumber7: "Regulated Licenses",
      globeButton: "  Start Trading Safely",
      investTitle: "From young investors to institutional market movers.",
      investTitles: "We offer services to all sorts of accounts.",
      stripeCardTitle: "Forex",
      stripeCardDes:
        "Trade the world’s largest financial market with ultra-tight spreads and instant execution. Major, minor, and exotic currencies — around the clock, 5 days a week, no downtime.",
      tradingStripe: "Start Trading",
      stripeCoomDes:
        "From gold to coffee — access physical markets through digital contracts. Hedge inflation or trade momentum.",
        srtripeThirdDes:
        "Digital volatility, real opportunity. Trade top cryptocurrencies with leverage and precision in a secure environment. *Available only in certain jurisdictions",
      stripeFourDesc:
        "Track and trade entire markets — S&P, DAX, NASDAQ and more — all from one account, in real time.",
      stripeFifth:
        "Oil, gas, and global demand in motion. Trade energy markets with responsive pricing and clear margins.",
      stripeSixth:
        "Build Your Wealth with the World's Most Powerful Companies — Everywhere.",
      newWealthDes:
        "Start testing in a demo environment before starting with your real account",
      newWealthDes2:
        "Whenever your ready for your wealth journey, we are ready for you.",
      legalTitle: "Legal Documents",

      legalTitleDes:
        "It’s important that you read and understand any documentation relating to the services you’re interested in. Anything that applies to your account will be clearly marked during the registration process. You should familiarise yourself with these ",
      legalTitleDes1: "documents before completing your registration. ",
      legalButton: "Open an account now",
      lagalSemiTitle1: "BBCorp Corporate Limited",
      lagalSemiTitle2: "BBCorp (SC) Limited",
      legalSemiTitle3: "BBCorp International MU Ltd",
      legalMainHead: "Business Terms and Policies (in English)",
      leagcard1: "Terms and Conditions",
      leagcard2: "VPS Terms and Condition",
      leagcard3: "Money Laundering prevention",
      leagcard4: "Order execution policy",
      leagcard5: "Risk Discloser for financial instruments",
      leagcard6: "Conflict of interest policy",
      leagcard7: "Complaint handling procedure",
    },

    /// Arabic to French  

    fr: {
      bannerTitle: "Né pour",
      bannerTitle2: "Les traders",
      bannerSubtitle: "Conçu pour performer",
      bannerDescription: "Agrée, liquide et conçu pour la vitesse — tout",
      bannerDescription2: "ce dont les traders sérieux ont besoin",
      openAccountButton: "Ouvrir un compte de trading",
      trading: "Commerce",
      promotions: "Promotions",
      Partnership: "Partenariat",
      company: "Entreprise",
      accountType: "Types de compte",
      signUp: "S'inscrire",
      SiggnUP: "Commencer",
      Accounts: "Comptes",
      Metalsbotom: "Prêt à trader des métaux avec",
      Metalsbotom1: "Start trading some of the most valuable assets on the planet with a",
      Metalsbotom2: "global broker. Open an account in seconds.",
      market: "Marché",
      companyInfo: "Entreprise",
      Platforms: "Plateformes",
      ourOffering: "Nos offres",
      Easy: "Easy Access to 1,400+ Global Assets",
      login: "Connexion",
      forexTrade: "Trading Forex",
      stockDerivatives: "Dérivés d'actions",
      commodities: "Matières premières",
      crypto: "Crypto",
      Indices: "Indices",
      Energies: "Énergies",Stocks: "Actions",
      preciousMetals: "Métaux précieux",
      shares: "Parts",
      cryptoCurrencies: "Cryptomonnaies",
      equityIndices: "Indices boursiers",
      energies: "Énergies",
      Referrals: "Parrainages",
      AllReff: "Parrainages (bientôt disponible)",
      ReComing: "(Bientôt disponible)",
      bbcropCopyTrading: "Copy trading BBCorp",
      bbcropCompetitions: "Compétitions BBCorp",
      executionPolicy: "Politique d’exécution",
      marginLeverage: "Marge & effet de levier",
      mt5Platforms: "Plateformes MT5",
      partnerWithUs: "Devenez partenaire avec nous",
      whoIsBBCorp: "KYC & LCB-FT",
      FoterSupport: "Support",
      careers: "Carrières",
      careersTitle: "Rejoignez Notre Équipe",
      careersSubtitle: "Faites partie d'une équipe dynamique qui façonne l'avenir du trading. Nous recherchons des individus passionnés prêts à faire une différence.",
      regulation: "Réglementation",
      legalDocuments: "Documents juridiques",
      bbcropAwards: "Récompenses BBCorp",
      contactUs: "Contactez-nous",
      helpCenter: "Centre d’aide",
      partnership: "Partenariat",
      easyAccessTo: "Accès facile à",
      global: "Mondial",
      assets: "Actifs",
      tradingNew:{
        titleLine1: "Découvrez le",
        titleLine2: "trading Forex",
        active: "Trading Forex",
        tradingBTN: "Ouvrir un compte de trading",
        subtitle: "Achetez et vendez sur les marchés mondiaux les plus liquides, comme l’EURUSD, 5 jours par semaine avec une exécution et des conditions de trading de premier plan.",      
      },
      tradingNew1: {
        titleLine1: "Découvrez les actions",
        active: "Dérivés d'actions",
        titleLine2: "Trading de dérivés",
        subtitle: "Tradez vos marques préférées, de Netflix à Apple, sous forme de dérivés d'actions avec des conditions et des tarifs compétitifs."
      },
      commoditiesTrading: {
        titleLine1: "Découvrez",
        active: "Matières premières",
        titleLine2: "Matières premières",
        subtitle: "Tradez des matières premières douces comme le café et le sucre dans d'excellentes conditions."
      },
      metalsTrading: {
        titleLine1: "Découvrez les métaux",
        active: "Métaux précieux",
        titleLine2: "Trading",
        subtitle: "Tradez des métaux précieux comme l'or et l'argent dans d'excellentes conditions."
      },
      sharesTrading: {
        titleLine1: "Découvrez",
        active: "Parts",
        titleLine2: "Parts",
        subtitle: "Tradez des actions réelles d'entreprises mondiales telles qu'Apple, Disney et Microsoft depuis votre compte BBCorp."
      },
      cryptoTrading: {
        titleLine1: "Découvrez la crypto",
        titleLine2: "Trading de dérivés",
        active: "Cryptomonnaies",
        subtitle: "Tradez des dérivés crypto, y compris le Bitcoin, à des prix en temps réel et dans des conditions inégalées."
      },
      equityIndicesTrading: {
        titleLine1: "Découvrez les",
        titleLine2: "indices boursiers",
        active: "Indices boursiers",
        subtitle: "Tradez des combinaisons d'actions de renommée mondiale avec notre sélection élite d’indices boursiers."
      },
      energiesTrading: {
        titleLine1: "Découvrez les énergies",
        titleLine2: "Trading",
        active: "Énergies",
        subtitle: "Tradez des variantes de pétrole et de gaz avec de faibles coûts et des conditions compétitives."
      },
      optionsTab: {
        name: "Trading Forex",
        name1: "Cryptomonnaies",
        name2: "Dérivés d'actions",
        name3: "Matières premières",
        name4: "Indices boursiers",
        name5: "Métaux précieux",
        name6: "Énergies",
        name7: "Actions"
      },
      whyTrade: "Pourquoi trader le Forex avec BBCorp ?",
whyTradeindices: "Pourquoi trader les indices boursiers avec BBCorp ?",
Tradesf: "Tradez les premières devises mondiales et les actifs les plus précieux de la planète.",
ClainT: "Réclamez votre part dans les entreprises les plus prospères au monde et augmentez votre potentiel.",
EnergiesD: "Profitez des énergies les plus liquides, réputées pour leur potentiel de trading.",
trafeEWn: "Pourquoi trader les énergies avec BBCorp ?",
trafeEWn1: "Pourquoi trader les énergies avec",
whyTradeSub: "Entrez sur le marché le plus liquide au monde avec la confiance d’avoir un courtier de premier plan à vos côtés.",

cardsDataeEn: {
  title1: "Tradez 24h/24, 5j/7",
  description1: "Explorez les marchés des devises mondiaux avec<br/> des opportunités de trading ininterrompues.",

  title2: "Restez connecté",
  description2: "Tradez en toute flexibilité, de WhatsApp à l’application MetaTrader 5 de BBCorp.",

  title3: "Amplifiez vos trades",
  description3: "Boostez le potentiel de vos trades avec<br/> un effet de levier adapté à tous les niveaux.",

  title4: "Oubliez les frais",
  description4: "Utilisez votre argent pour trader, pas pour payer des services.<br/> Profitez de l'absence de frais cachés ou de charges supplémentaires."
},
indicesCardData: {
  title: "Tradez plusieurs marques",
  description: "Vous pouvez trader des groupes de marques mondiales dans un seul actif, maximisant ainsi votre diversification.",

  title1: "Achetez et vendez des indices",
  description1: "Tradez sur des marchés en hausse comme en baisse avec les indices boursiers, en profitant de toutes les conditions.",

  title2: "Diversification du portefeuille",
  description2: "Réduisez les risques potentiels et accédez à un éventail plus large d’opportunités.",

  title3: "Oubliez les frais",
  description3: "Utilisez votre argent pour trader, pas pour payer des services — sans frais cachés ni charges supplémentaires."
},
energiesCardData: {
  title: "Tradez les meilleures énergies",
  description: "Vous pouvez trader des groupes de marques mondiales dans un seul actif, maximisant ainsi votre diversification.",

  title1: "Réduisez vos coûts",
  description1: "Tradez sur des marchés en hausse comme en baisse avec les indices boursiers, en profitant de toutes les conditions.",

  title2: "Amplifiez vos trades",
  description2: "Réduisez les risques potentiels et accédez à un éventail plus large d’opportunités.",

  title3: "Oubliez les frais",
  description3: "Utilisez votre argent pour trader, pas pour payer des services — sans frais cachés ni charges supplémentaires."
},
alternativeAssetsCardData: {
  title: "Diversifiez votre portefeuille",
  description: "Tradez des actifs alternatifs qui ont tendance à prospérer dans différentes conditions de marché.",

  title1: "Tradez sans posséder",
  description1: "Spéculez sur les mouvements de prix sans les tracas ni les coûts liés à la possession des actifs.",

  title2: "Amplifiez vos trades",
  description2: "Boostez le potentiel de vos trades grâce à un effet de levier adapté à tous les niveaux de traders.",

  title3: "Profitez de l'absence de frais supplémentaires",
  description3: "Concentrez-vous sur le trading sans commissions additionnelles ni frais cachés."
},

cardsDataCommom: {
  title: "Diversifiez votre portefeuille",
  description: "Diversifiez votre portefeuille avec des actifs influencés par différents fondamentaux et tendances.",

  title1: "Achetez et vendez (long/short)",
  description1: "Profitez de tous les mouvements de prix, y compris les tendances baissières.",

  title2: "Tradez sans posséder",
  description2: "Tradez des actifs sans vous soucier de leur possession physique.",

  title3: "Réduisez vos coûts",
  description3: "Tradez sans les frais élevés des bourses ni frais cachés."
},
cardDataEncosts: {
  title1: "Réduisez vos coûts",
  description1: "Évitez les frais de bourse et tradez directement depuis votre compte BBCorp.",

  title2: "Achetez et vendez des actions",
  description2: "Achetez et vendez des actifs pour profiter de toutes les conditions de marché.",

  title3: "0 % de commissions",
  description3: "Réduisez vos coûts et augmentez votre potentiel avec 0 % de commissions.",

  title4: "Tradez des fractions d’actions",
  description4: "Utilisez votre argent pour trader, pas pour payer des services. Aucuns frais cachés ni charges supplémentaires."
},

cardDataObj: {
  title1: "Tradez des actions mondiales",
  description1: "Tradez dans le monde entier avec un accès aux actions des États-Unis, d'Europe et du Royaume-Uni.",

  title2: "Accédez à des centaines d’options",
  description2: "Diversifiez avec des marques dans la tech, la mode, le voyage, le sport, et plus encore.",

  title3: "Réduisez vos coûts",
  description3: "Choisissez un trading rentable sans frais cachés.",

  title4: "Choisissez vos marques",
  description4: "Transformez les marques en lesquelles vous croyez en opportunités d’investissement."
},
ourInvestors: {
  title: "Découvrez les favoris de nos investisseurs",
  // favorites: "Favoris",
  subtitle: "Reconnus par l'industrie. Récompensant nos partenaires. Conçus pour évoluer avec vous.",
  metaTrader: {
    title: "MetaTrader 5",
    description: "Accédez à l'ensemble des services BBCorp avec l'application MT5, primée et très bien notée.",
    getItOn: "DISPONIBLE SUR",
    playStore: "Play Store",
    downloadOn: "Télécharger sur",
    appStore: "App Store",
    openAccount: "Ouvrir un compte"
  },
},
whatsAppTrading: {
  title: "Commerce WhatsApp ?",
  subtitle: "Ouvrez votre compte en moins de 2 minutes via notre portail WhatsApp BBCorp.",
  openWhatsApp: "Ouvrir le portail WhatsApp",

  title1: "Des dizaines de méthodes de dépôt",
  description1: "Ajoutez des fonds en toute simplicité grâce à une large gamme d’options de dépôt adaptées à vos besoins — des virements bancaires locaux et cartes de crédit aux stablecoins mondiaux et agents en espèces. Que vous soyez en déplacement ou à domicile, le financement de votre compte n’a jamais été aussi simple et flexible.",

  title2: "Infrastructure avancée et automatisation",
  description2: "Notre infrastructure basée sur l’IA supervise chaque étape — de l’intégration et du traitement des dépôts aux transactions en temps réel, à la surveillance comportementale, à la gestion des risques et aux retraits sans friction."
},

Discover: {
  title: "Conçu pour la croissance",
  subtitle: "Découvrez nos marchés",
  description: "Nous servons des clients institutionnels et particuliers exécutant des trades",
  description1: "dans le monde entier — en offrant précision, rapidité et fiabilité à tout moment",
  description2: "et en tout lieu."
},
Bonus: {
  title: "Parrainez et Gagnez",
  favorites: "Des conditions générales s’appliquent.",
  subtitle: "Gagnez des récompenses chaque fois qu’une personne parrainée s’inscrit et effectue des transactions. Partagez votre lien et recevez vos gains — c’est aussi simple que ça.",
  openAccount: "Réclamez votre bonus"
},

Competitions: {
  title: "Compétitions BBCorp",
  subtitle: "Tradez jusqu’au sommet et remportez votre part de",
  subtitle1: "plus de 100 000 $ en prix en espèces retirables.",
  openAccount: "Bientôt disponible"
},

deposit: {
  title: "300+ méthodes de dépôt",
  subtitle: "Des virements bancaires aux cryptos en passant par",
  subtitle1: "les fournisseurs de cash locaux, nous couvrons plus de",
  subtitle2: "180+ pays",
  openAccount: "Voir les méthodes de dépôt"
},
acountSection: {
  title: "Ouvrez et développez dès aujourd’hui",
  subtitle: "Ouvrez un compte dès aujourd’hui et accédez à une opportunité de faire croître votre patrimoine dans une institution sécurisée et fiable.",
  btnTitle: "Ouvrir un compte maintenant",
  
  cardsTitle: {
    title: "Compte Standard",
    title1: "Compte Trader",
    title2: "Compte Investisseur",
    sub: "Compte",
    subtitle: "Ouvrez notre compte le plus populaire, sans commission sur les trades.",
    subtitle1: "Parfait pour le trading à fort volume avec des spreads faibles, des swaps réduits et des commissions avantageuses.",
    subtitle2: "Vous souhaitez investir dans les actions ? Ouvrez un compte actions pour accéder aux opportunités du marché.",
    btnTitle: "Dépôt minimum 10 $",
    btnTitle1: "Dépôt minimum 10 $",
    btnTitle2: "Dépôt minimum 30 000 $",
    bltile: "Commencer",
    
    Markets: "Marchés",
    marketSub: "Forex, Métaux précieux, Indices boursiers, Cryptomonnaies, Indices thématiques, Actions, Turbo actions, Matières premières, Énergies",
    marketT1: "Éligibilité au bonus*",
    marketT2: "Options de compte Micro",
    marketT3: "100:1",
    marketT4: "Effet de levier maximum",
    marketT5: "20%",
    marketT6: "Niveau de stop-out",
    marketT7: "Sans swap",
    marketT8: "Commission",
    marketT9: "Dépôt minimum",
    marketT10: "10 $",
    marketT11: "Spreads à partir de",
    
    show: "Afficher plus",
    less: "Afficher moins",
    
    firsy: "Tous les comptes offrent une protection contre le solde négatif, le hedging, et des options islamiques en standard. Si la devise que vous déposez",
    firsy1: "sur votre compte n’est pas l’USD, le montant affiché est l’équivalent dans la devise de dépôt.",
    spreads: [
      {
        pair: "OR",
        value: "2.7",
      },
      {
        pair: "USD/JPY",
        value: "2",
      },
      {
        pair: "USD/JPY",
        value: "1.6",
      },
    ],
    tier: "*Certains pays peuvent être exclus",
  },
},
PickData: "Pick Your Pairs",
PickDatayour: "Pick your energies",
commonit: "Ready to Trade Commodities",
commonit1: "With BBCorp?",
commonitEqu1:
  "Start exploring some of the most popular indices with a leading",
commonitEqu2: "broker. Open an account within seconds.",
commonitEqu: "Ready to trade equity indices",
comment2:
  "Start trading popular Commodities with an industry-leading broker.",
comment3: "Open an account within seconds.",
PickDatayourDes: "You can see all trading hours in the Members Area.",
bttomTxt:
  " Explore beyond the top 10 Stock derivatives! Ready to discover more?",
RegisBTN: "Register to see more",
IndicesTitle: "Indices",
IndicesTitleFuture: "Future Indices",
moreInfo: " *More info",
IndicesTitleFutureCash: "Cash Energies",
RegisBTNindices: "Pick your equity indices",
RegisBTNiTitle: "You can see all trading hours in the Members Area.",
CommoditiesTile: "Pick Your Commodities",
CommoditiesTileDes: "You can see all trading hours in the Members Area.",
metalsTitle: "Pick your precious metals",
metalsTitleDes: "You can see all trading hours in the members area.",
shareTitle: "Pick Your Share",
Entitle:
  "Experience trading global energies with a leading broker that always",
Entitle1: "has your back. Open an account within seconds.",
shareTitleDes:
  "You can see all trading hours and stay updated on corporate events in the Members Area.",
tab1: "Standard",
tab2: "Ultra Low Standard",
tab3: "Futures",
derivate: "Pick Your Stock Derivatives",
desDerivate:
  "You can see all trading hours and stay updated on corporate events in the Members Area.",
tableData: {
  Symbol: "Symbol",
  AverageSpread: "Average Spread (pips)",
  Spread: "Spread as low as (pips)",
  MaxLeverage: "Max Leverage",
  Action: "Action",
},
picDec: "Le marché du Forex est ouvert du lundi au vendredi de 00h05 à 23h50 GMT+2",
footerAccounts: "Comptes",
footerMarket: "Marché",
footerOffering: "Notre Offre",
footerPlatform: "Plateformes",
footerSupport: "Support",
footerAccount: "Types de compte",
footerForex: "Trading Forex",
footerStock: "Dérivés d’actions",
blueBTN: "Commencez à trader maintenant",
footerCommaondities: "Matières premières",
footerPrecious: "Métaux précieux",
footerShares: "Actions",
cryptoTitle: "Choisissez vos cryptomonnaies",
cryptoTitleDes: "Le marché des cryptos fonctionne 24h/24 et 7j/7.",
footerCrypto: "Cryptomonnaies",
footerEquity: "Indices boursiers",
footerEnergies: "Énergies",
footerTrading: "BBCorp Copy Trading",
footerCompetitions: "Compétitions BBCorp",
footerPolicy: "Politique d’exécution",
footerLeverage: "Marge & Effet de levier",
footerMt5: "Plateformes MT5",
footerHelp: "Aide et Support",
footerContact: "Contactez-nous",
footerPolicy: "Politique de confidentialité",
footerTerm: "Conditions BBCorp",
footerButtontitle: "TÉLÉCHARGER SUR",
footerButtonName: "Google Play",
footerButton2title: "Télécharger sur",
footerButton2Name: "App Store",
footerPayment: "Paiement accepté",
footerLegal: "Documentation juridique",
footerCopy: "Droits d’auteur",
footerRight: "BBCorp LTD. Tous droits réservés",
footerNews: "Les CFD sont des instruments complexes et comportent un risque élevé de perte rapide en capital en raison de l’effet de levier. 77 % des comptes d’investisseurs particuliers perdent de l’argent lorsqu’ils négocient des CFD avec ce fournisseur. Vous devez vous interroger sur votre compréhension du fonctionnement des CFD et sur votre capacité à supporter un risque élevé de perte en capital. Nous vous recommandons de solliciter un avis professionnel avant d’investir. BBCorp Lebanon (Beirut Brokerage Corporation s.a.l) est réglementée par la Banque du Liban et supervisée par la Capital Markets Authority. Nous ne fournissons ni conseils en investissement ni services de gestion. Toute analyse, opinion, commentaire ou contenu de recherche disponible sur notre site internet est fourni uniquement à titre informatif et éducatif, et ne constitue en aucun cas une offre, une recommandation, un conseil ou une sollicitation d’achat ou de vente. Nous sommes heureux de recevoir des demandes d’ouverture de compte en provenance d’un large éventail de pays. Toutefois, bien que nous ne puissions actuellement accepter de demandes en provenance de certains pays, nous vous encourageons à postuler si vous remplissez nos critères d’éligibilité. Nous vous remercions de l’intérêt que vous portez à nos services. Les dépôts et retraits peuvent être coordonnés, facilités ou traités par une ou plusieurs entités affiliées.",
footerDescription:
  "Les CFD sont des instruments complexes et présentent un risque élevé de perte rapide en capital en raison de l'effet de levier. 77 % des comptes d'investisseurs particuliers perdent de l'argent lorsqu'ils négocient des CFD avec ce fournisseur. Vous devez vous demander si vous comprenez le fonctionnement des CFD et si vous pouvez vous permettre de prendre le risque élevé de perdre votre argent. Nous vous recommandons de demander un avis professionnel avant d'investir. BBcorp LTD (Comores) Limited est une société à responsabilité limitée constituée selon les lois de l’Union des Comores, sous le numéro d’enregistrement HV00724047, dont l’adresse enregistrée est Bonovo Road – Fomboni – Île de Mohéli – Union des Comores. BBCorp LTD (Comores) Limited est autorisée par la Mwali International Services Authority en tant que courtier international et maison de compensation sous le numéro de licence BFX2024241. Elle possède également un bureau physique à Chypre à l’adresse suivante : Taki Sofokleous 23A - 2049, Strovolos, Nicosie. Nous offrons uniquement un service d'exécution. Nous ne fournissons ni conseils en investissement ni services de gestion. Toute analyse, opinion, commentaire ou contenu de recherche sur notre site Web est destiné uniquement à des fins d’information et d’éducation, et ne constitue en aucun cas une offre, une recommandation, un conseil ou une sollicitation à acheter ou vendre. Nous acceptons volontiers les demandes de création de compte provenant d’un large éventail de pays. Toutefois, bien que nous ne puissions actuellement pas accepter les demandes de certains pays, nous vous encourageons à postuler si vous répondez à nos critères d’éligibilité, et nous vous remercions de l’intérêt que vous portez à nos services. Les dépôts et retraits peuvent être coordonnés, facilités ou traités par une ou plusieurs des filiales de BBCorp LTD, y compris BBcorp LB.",
weathTitle: "Commencez votre parcours vers la richesse",
weathTitles: " avec nous",
joinTitle: "Rejoignez-nous",
joinDes:
  "Nous avons été les pionniers de la politique stricte sans requotes ni rejets, qui a établi notre réputation. Pour éviter le slippage et aligner votre stratégie sur les prix du marché en temps réel, 99 % de toutes les transactions sont exécutées en moins d'une seconde.",
weathSetUp: "Configuration instantanée",
weathSupport: "Support 24h/24 et 7j/7",
weathLiquidity: "Liquidité élevée",
weathButton: "Contacter l'équipe commerciale",
sliderTitle: "Nos récompenses, votre avantage.",
sliderDescription:
  "Chez BBCorp, la conformité n’est pas une formalité — c’est une base. Nous opérons dans le cadre d’un ensemble croissant de normes réglementaires internationales garantissant que chaque aspect de notre activité est sécurisé, transparent et conçu pour évoluer à l’échelle mondiale. Alors que nous étendons notre présence sur de nouveaux marchés, nous restons engagés à maintenir les plus hauts niveaux de confiance, de gouvernance et d’intégrité opérationnelle.",
sliderCard1: "Meilleur courtier",
sliderCard2: "Moyen-Orient",
shareCom: "Pourquoi trader les actions",
shareCom1: "avec BBCorp ?",
shareComDes: "Réclamez votre part des entreprises les plus performantes du monde",
shareComDes1: "et développez votre potentiel.",
sliderCard3: "Le plus fiable",
sliderCard4: "Asie",
sliderCard5: "Courtier leader",
sliderCard6: "Afrique",
sliderCard7: "Croissance la plus rapide",
sliderCard8: "À l’échelle mondiale",
globeHead: "Reconnaissance internationale",
globeTitle: "Présence sur la scène mondiale",
globeDesc:
"Nous servons des clients institutionnels et particuliers effectuant des transactions dans le monde entier — en offrant précision, rapidité et fiabilité, à tout moment et en tout lieu.",
globeNumber: "10 000+",
globeNumbers: "1 000+",
globeNumber2: "Clients satisfaits",
globeNumber3: "2004",
globeNumber4: "Établi en",
globeNumber5: "Transactions",
globeNumber6: "3",
newWealthTitle: "Pas encore prêt pour",
newWealthTitle2: "le vrai marché ?",
globeNumber7: "Licences réglementées",
globeButton: "Commencez à trader en toute sécurité",
investTitle: "Des jeunes investisseurs aux acteurs institutionnels du marché,",
investTitles: "nous offrons des services pour tous types de comptes.",
stripeCardTitle: "Forex",
stripeCardDes:
"Tradez sur le plus grand marché financier mondial avec des spreads ultra-serrés et une exécution instantanée. Devises majeures, mineures et exotiques — 24h/24,5j/7,sans interruption.",
tradingStripe: "Commencer à trader",
stripeCoomDes:
"De l’or au café — accédez aux marchés physiques via des contrats numériques. Couvrez-vous contre l’inflation ou misez sur la dynamique du marché.",
srtripeThirdDes:
"Volatilité numérique, opportunité réelle. Tradez les principales cryptomonnaies avec effet de levier et précision dans un environnement sécurisé. *Disponible uniquement dans certaines juridictions",
stripeFourDesc:
"Suivez et tradez des marchés entiers — S&P, DAX, NASDAQ et plus encore — depuis un seul compte, en temps réel.",
stripeFifth:
"Pétrole, gaz et demande mondiale en mouvement. Tradez les marchés de l’énergie avec des prix réactifs et des marges claires.",
stripeSixth:
"Construisez votre richesse avec les entreprises les plus puissantes du monde — partout.",
newWealthDes:
"Commencez par tester dans un environnement de démonstration avant de passer à votre compte réel.",
newWealthDes2:
"Quand vous serez prêt à démarrer votre parcours de richesse, nous serons prêts pour vous.",
legalTitle: "Documents juridiques",
legalTitleDes:
"Il est important que vous lisiez et compreniez toute documentation relative aux services qui vous intéressent. Tout ce qui s’applique à votre compte sera clairement indiqué lors du processus d’inscription. Vous devez vous familiariser avec ces ",
legalTitleDes1:
"documents avant de finaliser votre inscription.",
legalButton: "Ouvrir un compte maintenant",
lagalSemiTitle1: "BBCorp Corporate Limited",
lagalSemiTitle2: "BBCorp (SC) Limited",
legalSemiTitle3: "BBCorp International MU Ltd",
legalMainHead: "Conditions commerciales et politiques (en anglais)",
leagcard1: "Termes et conditions",
leagcard2: "Conditions générales VPS",
leagcard3: "Prévention du blanchiment d’argent",
leagcard4: "Politique d’exécution des ordres",
leagcard5: "Divulgation des risques liés aux instruments financiers",
leagcard6: "Politique de gestion des conflits d’intérêts",
leagcard7: "Procédure de traitement des réclamations",
    },
  };

  const toggleLanguage = (newLang) => {
    if (newLang !== language) {
      const newPath = location.pathname.replace(/^\/(en|fr)/, `/${newLang}`);
      navigate(newPath, { replace: true });
    }
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, translations }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
